export default __webpack_public_path__ + "static/gallery-award-nylife-8323a3547155909d0143c784d4d42bc4.jpg";